<script>
    import {createEventDispatcher} from 'svelte';
    import {start} from 'tone';
    import Button from "@smui/button";

    export let pressed = false;
    export let disabled = false;

    // create a dispatcher for custom events
    const dispatch = createEventDispatcher();

    async function startContext(e) {
      await start();
      if (e.type === "mousedown" || e.type === "touchstart") {
        e.preventDefault();
      }
      pressed = !pressed;
      dispatch('changed', pressed);  // dispatch event whenever 'pressed' status changes
    }

    function keyEvent(e) {
      if (e.key === " " || e.key === "Enter") {
        dispatch('changed', pressed); // dispatch event whenever keys ' ' or 'Enter' pressed
        pressed = !pressed;
      }
    }


    function clicked(){
        console.log('clicked')
        started = !started
        started ? dispatch('start', { composed: true }): dispatch('stop', { composed: true })
    }

</script>

<Button class="play"
            disabled={disabled}
            pressed={pressed}
            on:mousedown={startContext}
            on:touchstart={startContext}
            on:mouseup={() => (pressed = false)}
            on:touchend={() => (pressed = false)}
            on:keydown={keyEvent}
            on:keyup={keyEvent}
            aria-label="Trigger"
            aria-checked={pressed}
            variant="unelevated"
            style="width: 100%; background-color: #ffffff; color:#3f0d81;">
  <slot></slot>
</Button>


<style lang="scss">
  @use "../theme/_smui-theme.scss";


</style>